export default "<app-tab-group [reportSection]=\"reportSection\"></app-tab-group>\r\n";